import { Link } from '@reach/router';
import { LessonsActivity } from 'api/lessonsApi';
import DefaultImage from 'images/lessons/Img_Default.jpg';
import React from 'react';

type Props = {
  activity: LessonsActivity;
  keyStageName: string;
  backPath: string;
  subtitle?: string;
  onPrint?: () => void;
};

const LessonTop: React.FC<Props> = ({
  activity,
  keyStageName,
  backPath,
  subtitle,
  onPrint,
  children,
}) => (
  <div
    className={`LessonTop ${
      activity.headerCSS ? `CupboardColour_${activity.headerCSS}` : ''
    }`}
  >
    <div className="WidthContent">
      <Link to={backPath} className="Btn BtnWhiteOrange BackButton LessonNoPrint">
        Back
      </Link>
      <div className="LessonTopTable">
        <div className="LessonTopDesc">
          <div className="LessonTopYear">{keyStageName}</div>
          <h1>{activity.name}</h1>
          {subtitle && <div className="LessonTopSubtitle">{subtitle}</div>}
          {onPrint && (
            <button
              type="button"
              className="Btn BtnOrange LessonNoPrint"
              onClick={onPrint}
            >
              Print
            </button>
          )}
          {children}
        </div>
        <div className="LessonTopImage">
          <img src={activity.imagePath || DefaultImage} alt={activity.name} />
        </div>
      </div>
    </div>
  </div>
);

export default LessonTop;
